/* ============
 * ProductDeposits Module
 * ============
 *
 * todo: add documentation here!
 */

import state from './state';
import mutations from './mutations';

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productDeposit/index.js